import * as React from 'react';
import styled from '../../theme';
const Title = styled.div `
  padding: 15px 10px;
  background-color: transparent;
  margin-top: 10px;
  color: #3f414d;
  font-size: 17px;
  font-weight: 700;
  max-width: 1140px;
  margin: 0px auto;
  text-align: ${({ isDesktop }) => (isDesktop ? 'center' : 'start')};
  @media ${(props) => props.theme.mq.md} { 
    font-size: 24px;
    font-weight: normal;
  }
`;
const List = styled.div `
  width: 100%;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  height: auto;
  margin-bottom: 12px;
  max-width: 1140px;
  display: flex;
  margin: ${({ isDesktop }) => (isDesktop ? '0px auto 28px' : '0px auto')};
`;
const Recommendation = (widgetData) => {
    const { params, children, isDesktop, } = widgetData;
    const { title, } = params;
    return (React.createElement(React.Fragment, null,
        title && (React.createElement(Title, { isDesktop: isDesktop }, title)),
        React.createElement(List, { isDesktop: isDesktop }, children.map((product) => (product)))));
};
export default Recommendation;
